import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorCode: {
		id: 'error-pages.common.error-code',
		defaultMessage: 'Error code: {errorCode}',
		description: 'Label that describes the corresponding error code for an error page',
	},
});
